/* src/config/middleware.js */

export const middleware = () => ({ dispatch, getState }) => next => action => {
  if (typeof action === 'function') return action(dispatch, getState);

  const { promise, types, ...rest } = action;
  if (!promise) return next(action);

  const [REQUEST, SUCCESS, FAILURE] = types;
  next({ ...rest, type: REQUEST });

  const actionPromise = promise({}, dispatch)
    .then(
      payload => next({ ...rest, payload, type: SUCCESS }),
      error => next({ ...rest, payload: error, type: FAILURE })
    )
    .catch(error => {
      console.log('Middleware Error: ', error);
      next({ ...rest, payload: error, type: FAILURE });
    });
  // return;
  return actionPromise;
};



// WEBPACK FOOTER //
// ./src/config/middleware.js